import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool, utils_tool, component_tool } from '@/tool'
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizNotice, WizBrowserExport } = component_tool;
let { checkStrLength, toChinesNum,Session } = utils_tool;
class OperateRecord extends WizContainer {
  componentName = 'OperateRecord';

  constructor(props) {
    super(props);
    const { history } = props;
    let infoDetail = {};
    if (history.location){
      if (history.location && history.location.record) {
        infoDetail = history.location.record;
        Session.set('infoDetail', infoDetail)
      } else {
        infoDetail = Session.get('infoDetail') || {};
      }
    }
    this.infoDetail = infoDetail;
    this.state = {
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '操作人',
        field: 'operatePersonName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '操作时间',
        field: 'operateTime',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '操作类型',
        field: 'operateType',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '关联实体类型',
        field: 'bizType',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '关联实体',
        field: 'bizContent',
        width: 100,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      }
    ]
    if (o['success']) {
      let data = o['data']
      WizBrowserExport({
        title: '点赞',
        sheetName: 'applicationManageInfo',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '点赞数据.xlsx',
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }
  _render() {
    let pathname = this.props && this.props.location && this.props.location.pathname
    let operateData = {}
    const data = this.infoDetail;
    if (pathname && (pathname === '/interact/community/invitation/invitationAgree' || pathname === '/interact/community/invitation/invitationStep')) {
      let bizType = 24 //帖子
      let bizId = data.searchProps && data.searchProps.invitation && data.searchProps.invitation.id //帖子ID
      let bizName = data.searchProps && data.searchProps.invitation && data.searchProps.invitation.content //帖子内容
      let operateType;
      if (pathname === '/interact/community/invitation/invitationAgree') {
        operateType = 1 //赞
      } else if (pathname === '/interact/community/invitation/invitationStep') {
        operateType = 2 //踩
      }
      operateData = {operateType, bizType, bizId,bizName}
    }
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig({ operateData: operateData }),
      apiDataFormat: {
        changeTop: this._handleCMD,
        changeScreen: this._handleCMD,
        export: this._handleFile,
      },
      operateData
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(OperateRecord);
